import React, { useEffect, useRef, useState } from "react";
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "../../Assets/Styles/pages/home.scss";
import AddText from "../../Components/AddText/addText";
import BatchPreview from "../../Components/BatchPreview/batchpreview";
import Canvas from "../../Components/Canvas/canvas";
import DateTime from "../../Components/DateTime/dateTime";
import DownloadBatch from "../../Components/DownloadBatch/downloadBatch";
import ImageProperties from "../../Components/ImageProperties/imageProperties.jsx";
import Nav from "../../Components/Nav/nav.jsx";
import SettingsModal from "../../Components/SettingsModal/settingsModal";
import ButtonRounded from "../../Components/Signature/button";
import Signature from "../../Components/Signature/signature";
import { EnumAlign } from "../../Config/config";
import helper_functions from "../../Config/helper_functions";
import { ClearImage } from "../../Redux/MainImage/imageSlice";
import {
  setBatchImages,
  setCreate_Template,
  setTemplate_Edit,
} from "../../Redux/UserSlice/userSlice";
import {
  deleteAll,
  setActiveId,
  setItem,
  setScreenShot,
} from "../../Redux/WaterMarks/wateramarks";
import { GetTemplateDataFromRedux } from "../../actions/Template/Template";
import { Prompt } from "react-router-dom/cjs/react-router-dom.min.js";
const Edit = () => {
  const ref = useRef();
  const { t } = useTranslation();
  const [create, setCreate] = React.useState(false);

  const [mainImage, setMainImage] = useState(null);
  const [waterMarks, setWaterMarks] = useState([]);

  const [hidden, setHidden] = React.useState(true);
  const [active, setActive] = React.useState("");
  const [choice, setChoice] = React.useState(false);
  const [openSignature, setOpenSignature] = React.useState(false);
  const [openDate, setOpenDate] = React.useState(false);
  const [openText, setOpenText] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);
  const [batchStarted, setBatchStarted] = useState(false);

  const [Urls, setUrls] = useState([]);

  const waterMarksState = useSelector((state) => state["watermarks"]);
  const file = useSelector((state) => state.mainImage);
  const downloadState = useSelector((state) => state["downloadSlice"]);
  const userSliceState = useSelector((state) => state["userSlice"]);
  const templateSlice = useSelector((state) => state["templateSlice"]);

  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (waterMarksState.activeId === "") {
      setActive("");
    }
  }, [waterMarksState.activeId]);

  useEffect(() => {
    if (!file.url) history.push("/home");
  });
  useEffect(() => {
    setHidden(false);
  }, [waterMarksState]);

  const handleDone = () => {
    if (downloadState.Quality) {
      setOpen(true);
    } else setOpenSettings(true);
  };

  useEffect(() => {
    if (mainImage)
      return () => {
        dispatch(setCreate_Template(false));
        if (file.batchurls.length && userSliceState.template_Edit) {
          dispatch(setTemplate_Edit(false));
          dispatch(deleteAll());

          var url = file.batchurls[file.currentIndex];

          if (url.hasOwnProperty("template")) {
            var id = url.template;
            setTimeout(() => {
              dispatch(
                GetTemplateDataFromRedux(
                  id,
                  templateSlice,
                  waterMarksState,
                  false
                )
              );
            }, 100);
          } else {
            var tempID = userSliceState.current_TemplateID;
            if (file.orientation === "landscape") {
              if (tempID.landcsapeTemp) tempID = tempID.landcsapeTemp;
              else {
                if (tempID.portraitTemp) tempID = tempID.portraitTemp;
              }
            } else if (file.orientation === "portrait") {
              if (tempID.portraitTemp) tempID = tempID.portraitTemp;
              else {
                if (tempID.landcsapeTemp) tempID = tempID.landcsapeTemp;
              }
            }
            var template = userSliceState.template;

            template = template.filter((item) => item.id === tempID)[0];
            setTimeout(() => {
              dispatch(
                setScreenShot({
                  type: "image",
                  property: "template",
                  id: Date.now(),
                  x: 50,
                  y: 50,
                  deg: 0,
                  scaleX: 1,
                  scaleY: 1,
                  src: template.media.originalUrl,
                  opacity: 1,
                })
              );
            }, 100);
          }
        } else {
          dispatch(setBatchImages(false));
          dispatch(ClearImage());
          dispatch(deleteAll());
        }
      };
  }, []);
  const handleCancel = async () => {
    if (window.confirm(t("CancelCnofirmation"))) {
      dispatch(setCreate_Template(false));
      if (file.batchurls.length && userSliceState.template_Edit) {
        dispatch(setTemplate_Edit(false));
        dispatch(deleteAll());
        var url = file.batchurls[file.currentIndex];
        if (url.hasOwnProperty("template")) {
          var id = url.template;
          setTimeout(() => {
            dispatch(
              GetTemplateDataFromRedux(
                id,
                templateSlice,
                waterMarksState,
                false
              )
            );
          }, 100);
        } else {
          var tempID = userSliceState.current_TemplateID;
          if (file.orientation === "landscape") {
            if (tempID.landcsapeTemp) tempID = tempID.landcsapeTemp;
            else {
              if (tempID.portraitTemp) tempID = tempID.portraitTemp;
            }
          } else if (file.orientation === "portrait") {
            if (tempID.portraitTemp) tempID = tempID.portraitTemp;
            else {
              if (tempID.landcsapeTemp) tempID = tempID.landcsapeTemp;
            }
          }
          var template = userSliceState.template;
          template = template.filter((item) => item.id === tempID)[0];
          setTimeout(() => {
            dispatch(
              setScreenShot({
                type: "image",
                property: "template",
                id: Date.now(),
                x: 50,
                y: 50,
                deg: 0,
                scaleX: 1,
                scaleY: 1,
                src: template.media.originalUrl,
                opacity: 1,
              })
            );
          }, 100);
        }
      } else {
        dispatch(setBatchImages(false));
        dispatch(ClearImage());
        dispatch(deleteAll());
      }
    }
  };

  const dispatch = useDispatch();

  const onFileChange = (event) => {
    if (!event.target.files) return;

    const logo = URL.createObjectURL(event.target.files[0]);
    if (!logo) return;

    dispatch(
      setItem({
        type: "image",
        property: "file",
        id: Date.now(),
        x: 50,
        y: 50,
        deg: 0,
        scaleX: 1,
        scaleY: 1,
        src: logo,
        opacity: 1,
      })
    );
  };

  const onSignatureApply = (url) => {
    let logo = url;
    logo = helper_functions.dataURLtoFile(logo, "signature.png");
    if (logo !== null) {
      dispatch(
        setItem({
          type: "image",
          property: "signature",
          id: Date.now(),
          x: 50,
          y: 50,
          deg: 0,
          scaleX: 0.25,
          scaleY: 0.25,
          src: logo,
          opacity: 1,
          alignEnable: EnumAlign.None,
          src_type: logo.type,
          name: logo.name,
          size: logo.size,
        })
      );
      setActive("signature");
    }
  };
  const AddEdit = async (event) => {
    await ref.current.addNewItem(event);
    dispatch(setActiveId(""));
  };

  const handleDeleteKeyPress = (event) => {
    if (event.keyCode === 46 || event.key === "Delete") {
      if (ref.current) {
        ref.current.deleteCurrentItem();
      }
    }
  };

  if (active) {
    window.addEventListener("keydown", handleDeleteKeyPress);
  }

  return (
    <>
      <Prompt
        when={file.url ? true : false}
        message="You have unsaved changes, are you sure you want to leave?"
      />
      {!(
        mainImage ||
        (userSliceState.edit_Template &&
          (waterMarks.length || waterMarksState.deletedWaterMarkIds)) ||
        userSliceState.batchDownload
      ) ||
        (waterMarksState.waterMarksloader && (
          <div className="circular-progress-bar"></div>
        ))}
      <Row // onKeyDown={(e) => ArrowsClicked(e)}
        tabIndex={-1}
        className="m-0 home   "
      >
        {!(file.batchurls.length > 0) ? (
          <>
            <div className="d-flex flex-column p-0 h_total side_bar">
              <Nav
                deselect={() => {
                  dispatch(setActiveId(""));
                }}
                userSliceState={userSliceState}
                setHidden={setHidden}
                setOpenSignature={setOpenSignature}
                openSignature={openSignature}
                setCreate={setCreate}
                hidden={hidden}
                active={active}
                setOpenDate={setOpenDate}
                setOpenText={setOpenText}
                setActive={setActive}
              />
            </div>
          </>
        ) : (
          <div
            className={`${
              !userSliceState.template_Edit
                ? "d-flex flex-column w_27"
                : " d-none"
            }`}
          >
            <div className="d-flex h_total_max">
              <BatchPreview userSliceState={userSliceState} />
            </div>
          </div>
        )}
        {(userSliceState.template_Edit || !file.batchurls.length) && (
          <div
            onClick={() => {
              if (hidden) dispatch(setActiveId(""));
            }}
            className={` ${
              !hidden && active !== "" && "shadow"
            } p-0 w_23 h_total_max mx-0 d-flex flex-column justify-content-end`}
          >
            {!hidden && active !== "" ? (
              <>
                <ImageProperties
                  ref={ref}
                  choice={choice}
                  openSignature={openSignature}
                  setOpenSignature={setOpenSignature}
                  setChoice={(e) => setChoice(e)}
                  setActive={setActive}
                  setHidden={setHidden}
                  onFileChange={onFileChange}
                  active={active}
                  onSignatureApply={onSignatureApply}
                  userSliceState={userSliceState}
                  file={file}
                />
                {!(active === "sticker" || active === "template") &&
                !userSliceState.template_Edit ? (
                  <Row className="bottom_buttons text-center m-0 p-0  py-2 d-flex justify-content-center align-items-center Aktiv">
                    <ButtonRounded
                      onclick={() => ref.current.deleteCurrentItem()}
                      text={choice ? t("Nav.Delete") : t("Nav.Cancel")}
                      style={"w_edit_button text-black cancelEdit  m-0"}
                      parrentStyle="w_max me-3 p-0 align-items-center"
                    />
                    <ButtonRounded
                      onclick={(event) => {
                        AddEdit(event);
                        setHidden(true);
                        setActive("");
                      }}
                      text={choice ? t("Nav.Done") : t("Nav.Add")}
                      style={"w_edit_button doneEdit"}
                      parrentStyle="w_max ms-3 p-0 my-1 align-items-center"
                    />
                  </Row>
                ) : null}
              </>
            ) : null}
          </div>
        )}
        <div
          className={`canvas_wrapper h_total_max noScroller d-flex justify-content-center p-0`}
          style={{ width: "fit-content" }}
        >
          <Canvas
            create={create}
            active={active}
            setActive={setActive}
            setCreate={setCreate}
            Urls={Urls}
            setUrls={setUrls}
            mainImage={mainImage}
            setMainImage={setMainImage}
            waterMarks={waterMarks}
            setWaterMarks={setWaterMarks}
            batchStarted={batchStarted}
          />
        </div>
        <div
          className="w_23 px-0"
          onClick={() => {
            dispatch(setActiveId(""));
          }}
        >
          <Row className="hover_home_buttons text_15 productSansLight  d-flex justify-content-center mx-2">
            <Row className=" m-0 p-0 w-100">
              <ButtonRounded
                onclick={handleCancel}
                text={"Cancel"}
                style={`w_edit_button ${
                  !(file.batchurls.length > 0)
                    ? "bg_cancel_normal text-white "
                    : null
                } cancelbutton  my-0 mb-0 p-0`}
                parrentStyle={
                  file.batchurls.length > 0
                    ? !userSliceState.template_Edit && "w-50"
                    : "w-100"
                }
              />
              {file.batchurls.length > 0 && !userSliceState.template_Edit ? (
                <ButtonRounded
                  onclick={handleDone}
                  text={"Done"}
                  style={"w_edit_button  my-0 mb-0 p-0"}
                  parrentStyle={"w-50"}
                />
              ) : null}
            </Row>
          </Row>
        </div>
      </Row>

      <DateTime setOpen={setOpenDate} setActive={setActive} open={openDate} />
      <AddText setOpen={setOpenText} setActive={setActive} open={openText} />
      <Signature
        onSignatureApply={onSignatureApply}
        setActive={setActive}
        openSignature={openSignature}
        setOpenSignature={setOpenSignature}
      />
      <DownloadBatch
        open={open}
        setOpen={setOpen}
        urls={Urls}
        setUrls={setUrls}
        setBatchStarted={setBatchStarted}
      />
      <SettingsModal
        open={openSettings}
        setOpen={setOpenSettings}
        handleDone={handleDone}
        parent={true}
      />
    </>
  );
};

export default Edit;
